export const multimediaErrorMessageMap: Record<number, string> = {
  2000: 'Autoplay permission for audio and video is not enabled',
};
export const multimediaErrorDisplayMessageMap = {
  2000: '音视频自动播放权限未开启',
};
